import { createFileRoute } from '@tanstack/react-router';

import { QcChecklistEditPage, qcTemplateQueryOptions } from '@/features/workflows';

export const Route = createFileRoute(
  '/_authed/_active/s/$storeId/settings/qc-checklists/$checklistId',
)({
  staticData: { tours: ['qc.editor'] },
  loader: async ({ context, params }) => {
    const checklist = await context.queryClient.query({
      ...qcTemplateQueryOptions(params.storeId, params.checklistId),
      staleTime: 'static',
    });
    return { crumb: checklist.name };
  },
  component: QcChecklistEditPage,
});
